module.exports = __webpack_public_path__ + "img/201.f5cdfd33.png";